import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { putPassword } from '../Api'

export default generateApiAction({
  baseType: Types.AUTH.PASSWORD,
  api: putPassword,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/auth/ChangePasswordAction.js